module.exports = __webpack_public_path__ + "static/media/youth.dd0e2a40.png";